var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTradesPosition3Image(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58701 23.1138L29.6244 8.55578L49.6617 23.1138L42.0081 46.6691H17.2406L9.58701 23.1138Z",
    fill: "#581DAD",
    fillOpacity: 0.05,
    stroke: "url(#paint0_linear_1820_2216)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5268 13.9674L40.1586 11.3785L50.2325 34.0048L31.8266 50.5775L10.3773 38.1937L15.5268 13.9674Z",
    fill: "#CC8CFB",
    fillOpacity: 0.05,
    stroke: "url(#paint1_linear_1820_2216)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0796 26.482C26.1262 25.5487 26.4529 24.83 27.0596 24.326C27.6756 23.8127 28.4829 23.556 29.4816 23.556C30.1629 23.556 30.7462 23.6773 31.2316 23.92C31.7169 24.1533 32.0809 24.4753 32.3236 24.886C32.5756 25.2873 32.7016 25.7447 32.7016 26.258C32.7016 26.846 32.5476 27.3453 32.2396 27.756C31.9409 28.1573 31.5816 28.428 31.1616 28.568V28.624C31.7029 28.792 32.1229 29.0907 32.4216 29.52C32.7296 29.9493 32.8836 30.5 32.8836 31.172C32.8836 31.732 32.7529 32.2313 32.4916 32.67C32.2396 33.1087 31.8616 33.454 31.3576 33.706C30.8629 33.9487 30.2656 34.07 29.5656 34.07C28.5109 34.07 27.6522 33.804 26.9896 33.272C26.3269 32.74 25.9769 31.956 25.9396 30.92H27.8436C27.8622 31.3773 28.0162 31.746 28.3056 32.026C28.6042 32.2967 29.0102 32.432 29.5236 32.432C29.9996 32.432 30.3636 32.3013 30.6156 32.04C30.8769 31.7693 31.0076 31.424 31.0076 31.004C31.0076 30.444 30.8302 30.0427 30.4756 29.8C30.1209 29.5573 29.5702 29.436 28.8236 29.436H28.4176V27.826H28.8236C30.1489 27.826 30.8116 27.3827 30.8116 26.496C30.8116 26.0947 30.6902 25.782 30.4476 25.558C30.2142 25.334 29.8736 25.222 29.4256 25.222C28.9869 25.222 28.6462 25.3433 28.4036 25.586C28.1702 25.8193 28.0349 26.118 27.9976 26.482H26.0796Z",
    fill: "#FBD365"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1820_2216",
    x1: 29.6244,
    y1: 7.93774,
    x2: 29.6244,
    y2: 51.3109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA53A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1820_2216",
    x1: 40.4677,
    y1: 10.8433,
    x2: 18.7811,
    y2: 48.4055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA53A0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradesPosition3Image);
export default __webpack_public_path__ + "static/media/TradesPosition3Image.ced6464760173773a587a462b72bde86.svg";
export { ForwardRef as ReactComponent };